import { styled, Stack } from '@mui/material';

import { pxToRem } from '~/utils/getFontValue';

export const FieldsContainer = styled(Stack)({
  gap: pxToRem(18),
});
